import type ProductsCard from "@travily/types/models/ProductsCard";
import type {
  ProductsCardPhotosTrait,
  ProductsCardPricingTrait,
  ProductsCardReviewsTrait,
} from "@travily/types/models/ProductsCard";
import type ServicesCard from "@travily/types/models/ServicesCard";
import type {
  ServicesCardPhotosTrait,
  ServicesCardPricingTrait,
  ServicesCardReviewsTrait,
} from "@travily/types/models/ServicesCard";
import { Products } from "./components/Products";
import { Services } from "./components/Services";

export type StoreProduct = ProductsCard & ProductsCardPhotosTrait & ProductsCardPricingTrait & ProductsCardReviewsTrait;
export type StoreService = ServicesCard & ServicesCardPhotosTrait & ServicesCardPricingTrait & ServicesCardReviewsTrait;

export interface StorePanelProps {
  canCreateListing?: boolean;
  products: StoreProduct[];
  services: StoreService[];
  onAddProduct?: () => void;
  onAddService?: () => void;
}

/** Storefront content shared by all profile types' store pages. */
export function StorePanel({ canCreateListing, products, services, onAddProduct, onAddService }: StorePanelProps) {
  return (
    <>
      {(products.length > 0 || canCreateListing) && (
        <div className="mt-8 w-full lg:mt-12">
          <Products onAddProduct={onAddProduct} products={products} />
        </div>
      )}
      {(services.length > 0 || canCreateListing) && (
        <div className="mt-8 w-full lg:mt-12">
          <Services onAddService={onAddService} services={services} />
        </div>
      )}
    </>
  );
}
